import React from "react";
import FadingCarousel from "../FadingCarousel/FadingCarousel";
import INeedTo from "../iNeed2_Slides/INeedTo";
import WhurzIt from "../WhurzIt/WhurzIt";
import PcTran from "../pctran/PcTran";
import Portfolio from "../Portfolio/Portfolio";
import Connect from "../Connect/Connect";
import "./WebApps.css";

// By extending the React.Component class, TextArea inherits functionality from it
class WebApps extends React.Component 
{

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);

	    // Setting the initial state of the TextArea component
	    this.state = 
	    {
	        initial: false
	    };

    } // End of constructor()

    render()
    {

        return(

            <div>
                <div className="container" />
	    	<div className="row">
            <div className="col-md-8 col-sm-10 WebAppsMain">
            
                

                <FadingCarousel name="sam"
                     componentArray=
                    {
                        [   <Portfolio name="This Web Site"/>,
                            <WhurzIt name="WhurzIt"/>,
                            <INeedTo name="iNeed2"/>,
                            <PcTran name="Somename"/>
                        ]
                    
                    }
                    labelArray=
                    {
                        [
                            "This Web Site",
                            "WhurzIt",
                            "Ineed2",
                            "PC-Tran"
                        ]
                    }
                />
                </div>

                <div className="col-md-3 sam">

                    <div className="row">
                        <div className="col-md-12">
                        <Connect/>
                        </div>
                    </div>

                    

                </div>
            </div>
            </div>
                

                
                


                

                )
    } // End of render

} // End of class WebApps

export default WebApps;


// WEBPACK FOOTER //
// ./src/components/WebApps/WebApps.js